import React from "react";
import { ClientPractitionerClientType } from "../../SignUpFormTypes/ClientPractitionerClient";
const ClientPractitionerClient: React.FC<ClientPractitionerClientType> = ({
  clientPractitionerSelectionHeader,
  practitionerCopy,
  practitionerSubcopy,
  practitionerImage,
  practitionerImageAltText,
  clientCopy,
  clientSubcopy,
  clientImage,
  clientImageAltText,
  advanceNextStep,
}) => {
  const clickStepZero = (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => {
    advanceNextStep(e);
  };

  return (
    <section className="client-practitioner sm:px-5 flex justify-center w-full sign-up--rebrand-container">
      <div className="flex flex-col sm:gap-6 gap-8 sm:w-full sm:min-w-full min-w-[511px] sm:max-w-full max-w-[511px] header4">
        <h4 className="flex justify-center items-center text-forest-900 text-center font-medium not-italic">
          {clientPractitionerSelectionHeader}
        </h4>
        <div className="flex flex-col sm:gap-3 sm:self-stretch gap-4 min-w-[335px]">
          <button
            className="flex hover:cursor-pointer hover:bg-sun-100 hover:border-sun-200 active:bg-sun-300 bg-transparent active:border-sun-600 sm:p-4 p-6 border-[1.5px] border-solid sm:rounded-2xl rounded-3xl border-forest-200 self-stretch sm:gap-4 gap-6 items-center"
            onClick={clickStepZero}
          >
            <div
              className="flex w-16 h-16 items-center justify-center"
              style={{ padding: "6.4px 11.9px 6.4px 12.1px" }}
            >
              <img
                src={practitionerImage}
                alt={practitionerImageAltText}
                width={40.096}
                height={51.2}
                className="flex max-w-none flex-shrink-0"
              />
            </div>
            <div className="flex flex-col py-[5px] font-sans font-normal">
              <div className="client-practitioner__text text-[21px] leading-[150%] tracking-[-0.21px] text-left">
                {practitionerCopy}
              </div>
              <div className="text-forest-700 text-[13px] leading-[170%] text-left">
                {practitionerSubcopy}
              </div>
            </div>
          </button>

          <a
            href="/c/client-interim/"
            onClick={clickStepZero}
            className="flex hover:cursor-pointer no-underline hover:bg-sun-100 hover:border-sun-200 active:bg-sun-300 active:border-sun-600 sm:p-4 p-6 border-[1.5px] border-solid sm:rounded-2xl rounded-3xl border-forest-200 self-stretch sm:gap-4 gap-6 items-center"
          >
            <div
              className="flex w-16 h-16 items-center justify-center"
              style={{ padding: "6.4px 4.9px 6.4px 5.12px" }}
            >
              <img
                src={clientImage}
                alt={clientImageAltText}
                width={53.976}
                height={51.2}
                className="flex max-w-none flex-shrink-0"
              />
            </div>
            <div className="flex flex-col py-[5px] font-sans font-normal text-left">
              <div className="client-practitioner__text text-[21px] leading-[150%] tracking-[-0.21px]">
                {clientCopy}
              </div>
              <div className="text-forest-700 text-[13px] leading-[170%] text-left">
                {clientSubcopy}
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ClientPractitionerClient;
